import React,{Component} from 'react';
import moment from 'moment'
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import AccountsApi from '../../api/accounts';
import { showError, confirmAction, showMessage } from '../../actions/uiActions';

class MyStudentDataUploader extends Component
{
    state=
    {
        uploading:false,
        file:"",
        fileName:""
    };

    fileInputRef = null;

    setInputRef = element => {
        this.fileInputRef = element
    }

    readFileContent = (file) => {
        const reader = new FileReader()
        return new Promise((resolve, reject) => {
            reader.onload = event => resolve(event.target.result)
            reader.onerror = error => reject(error)
            reader.readAsText(file)
        });
    }

    performUpload = async (uploadedFile) => {
        try {
            const formData= new FormData();
            formData.append(this.props.name, uploadedFile, uploadedFile.name);
            const myStudentData = await AccountsApi.uploadMyStudentData(this.props.id,formData)
            this.setState({ uploading: false });
            this.props.onUpload(myStudentData);
        } catch (error) {
            this.setState({ uploading: false });
            this.props.showError(error.response.data.message);

        }
    }
    
    openFileDialog =()=> {
        var fileInputDom = ReactDOM.findDOMNode(this.fileInputRef)
        fileInputDom.click()
      }
      handleFile = async (event) => {
        if(event.target.files&&event.target.files.length)
        {
            try {
                const uploadedFile = event.target.files[0];
                this.setState({fileName:uploadedFile.name,uploading:true});
                const text = await this.readFileContent(uploadedFile);
                const requestDateLine = text?.split('\n').find((line) => line.toLowerCase().includes('request date'));
                const msdDate = requestDateLine.split(":")[1];
                if (moment(msdDate, "YYYY-MM-DD-HH.mm.ss").isBefore(moment('2022-07-01', 'YYYY-MM-DD'))) {
                    return this.props.showMessage('The studentaid.gov website recently updated all MSDs. Can you please download your MSD again');
                }
                if (moment().diff(moment(msdDate, "YYYY-MM-DD-HH.mm.ss"), "weeks") > 12) {
                    this.props.confirmAction("MSD is more than 3 months old. Your analysis may not be very accurate and recent. Do you still want to continue?", async () => {
                        await this.performUpload(uploadedFile)
                    }, "Old MSD", "Yes", "No", () => {
                        this.setState({ file: "", fileName:"", uploading: false });
                    });
                } else {
                    await this.performUpload(uploadedFile)
                }
            } catch (error) {
                this.setState({ file: "", fileName:"", uploading: false });
                this.props.showError("Please check the file you uploaded and confirm it is a text file and try again. If error persists contact support");
            } finally {
                this.fileInputRef.value = null;
            }
        }
      }
    render()
    {
        return (
            <span><button style={{marginLeft:20}} className={this.props.className} disabled={this.state.uploading} 
                onClick={this.openFileDialog}>{this.props.children}</button>
              <input
                type='file'
                multiple={this.props.multi}
                ref={this.setInputRef}
                style={{ display: 'none' }}
                accept={this.props.accept}
                onChange={this.handleFile} />
            </span>
          );
    }
    
}

export default connect(null, { showError, confirmAction, showMessage })(MyStudentDataUploader);